import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { onSystemThemeChange } from 'store/slices/themeSlice';
import {
  hasStoredThemeChoice,
  subscribeToSystemTheme,
} from 'utils/themeStorage';

// Mantiene el CSS del template (light/dark-theme.css) alineado con
// state.theme.currentTheme y, si el usuario nunca eligió tema, sigue los
// cambios de preferencia del sistema operativo.
export default function useThemeSync() {
  const dispatch = useDispatch();
  const currentTheme = useSelector((state) => state.theme.currentTheme);
  const { switcher, themes, currentTheme: loadedTheme } = useThemeSwitcher();

  useEffect(() => {
    if (loadedTheme && loadedTheme !== currentTheme) {
      switcher({ theme: themes[currentTheme] });
    }
  }, [currentTheme, loadedTheme, switcher, themes]);

  useEffect(
    () =>
      subscribeToSystemTheme((systemTheme) => {
        if (!hasStoredThemeChoice()) {
          dispatch(onSystemThemeChange(systemTheme));
        }
      }),
    [dispatch],
  );
}
